function getItemStub(write = false) {
  return {
    setItemErrors() {},
    itemId: "fake-id",
    permissions: {
      expert: { includes: () => true },
      read: { includes: () => true },
      write: { includes: () => write },
      delete: { includes: () => false },
    },
    itemErrors: {},
  };
}

const stubs = {
  formik: {
    setFieldValue() {},
    validateForm() {},
    handleBlur() {},
    errors: {},
    values: {},
  },
  item: getItemStub(),
  itemWrite: getItemStub(true),
  itemErrors: {},
};

export default stubs;
